module.exports = __webpack_public_path__ + "img/uqc.19ebfb72.gif";